module.exports = __webpack_public_path__ + "static/media/frame-bkg.d2dcee32.svg";